var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { faCopy, faDownload, faEdit, faLink, faPlusSquare, faShareAlt, faTrashRestore, faUpload, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BButtonGroup } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { undeleteWorkflow } from "@/components/Workflow/workflows.services";
import { useConfirmDialog } from "@/composables/confirmDialog";
import { Toast } from "@/composables/toast";
import { useUserStore } from "@/stores/userStore";
import { useWorkflowActions } from "./useWorkflowActions";
import AsyncButton from "@/components/Common/AsyncButton.vue";
import WorkflowRunButton from "@/components/Workflow/WorkflowRunButton.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowActionsExtend',
    props: {
        workflow: null,
        published: { type: Boolean, default: false },
        editor: { type: Boolean, default: false },
        current: { type: Boolean, default: false }
    },
    emits: ["refreshList", "insert", "insertSteps"],
    setup(__props, { emit }) {
        const props = __props;
        const userStore = useUserStore();
        const { confirm } = useConfirmDialog();
        const { isAnonymous } = storeToRefs(useUserStore());
        const shared = computed(() => {
            return !userStore.matchesCurrentUsername(props.workflow.owner);
        });
        function onRestore() {
            return __awaiter(this, void 0, void 0, function* () {
                const confirmed = yield confirm("Are you sure you want to restore this workflow?", "Restore workflow");
                if (confirmed) {
                    yield undeleteWorkflow(props.workflow.id);
                    emit("refreshList", true);
                    Toast.info("Workflow restored");
                }
            });
        }
        const editButtonTitle = computed(() => {
            if (isAnonymous.value) {
                return "Log in to edit Workflow";
            }
            else {
                if (props.workflow.deleted) {
                    return "You cannot edit a deleted workflow. Restore it first.";
                }
                else {
                    return "Edit Workflow";
                }
            }
        });
        const importedButtonTitle = computed(() => {
            if (isAnonymous.value) {
                return "Log in to import workflow";
            }
            else {
                return "Import this workflow to edit";
            }
        });
        const runButtonTitle = computed(() => {
            if (isAnonymous.value) {
                return "Log in to run workflow";
            }
            else {
                if (props.workflow.deleted) {
                    return "You cannot run a deleted workflow. Restore it first.";
                }
                else {
                    return "Run workflow";
                }
            }
        });
        const { copyPublicLink, copyWorkflow, downloadUrl, importWorkflow } = useWorkflowActions(computed(() => props.workflow), () => emit("refreshList", true));
        return { __sfc: true, props, emit, userStore, confirm, isAnonymous, shared, onRestore, editButtonTitle, importedButtonTitle, runButtonTitle, copyPublicLink, copyWorkflow, downloadUrl, importWorkflow, faCopy, faDownload, faEdit, faLink, faPlusSquare, faShareAlt, faTrashRestore, faUpload, FontAwesomeIcon, BButton, BButtonGroup, AsyncButton, WorkflowRunButton };
    }
});
